import { type CoreChatComponent, CORE_CHAT_NAME } from "@b2bportal/core-chat";
import { useStyles } from "@b2bportal/core-themes";

export const useChatStyles = (
  componentName: keyof typeof CoreChatComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_CHAT_NAME, componentName, defaultStyles);
};
